// extracted by mini-css-extract-plugin
module.exports = {"root":"Login_root__cxDvD","button_container":"Login_button_container__3Ki0e","remember":"Login_remember__2LDkp","link":"Login_link__1-ylG","signup":"Login_signup__2xjYI"};